import '../../styles/styles.scss';
import menu from './menu';
import ani from './ani';
import jobsSearch from './jobs-search';

menu();
ani();
jobsSearch();
